const DEPARTING_ROUTE_ARTIFACT_SELECTOR = [
  "body > .autocomplete-content.dropdown-content",
  "body > .datepicker-modal",
  "body > .material-tooltip",
  "body > .modal-overlay",
].join(", ");

const ROUTE_ROOT_CLASSES = {
  authAdd: ["auth-add-active"],
};

const getRouteComponent = (route) => {
  const matched = route?.matched || [];
  const record = matched[matched.length - 1];
  return record?.components?.default || null;
};

const isComponentChange = (to, from) => {
  const fromComponent = getRouteComponent(from);
  const toComponent = getRouteComponent(to);

  return Boolean(fromComponent && fromComponent !== toComponent);
};

export const captureDepartingRouteLayout = (to, from) => {
  if (typeof document === "undefined" || !isComponentChange(to, from)) {
    return null;
  }

  return {
    artifacts: Array.from(document.querySelectorAll(DEPARTING_ROUTE_ARTIFACT_SELECTOR)),
    rootClasses: ROUTE_ROOT_CLASSES[from?.name] || [],
  };
};

export const cleanupDepartingRouteLayout = (snapshot) => {
  if (!snapshot || typeof document === "undefined") {
    return;
  }

  snapshot.artifacts.forEach((element) => {
    if (element?.isConnected && element.parentElement === document.body) {
      element.remove();
    }
  });

  snapshot.rootClasses.forEach((className) => {
    document.documentElement.classList.remove(className);
  });
};

export const scheduleDepartingRouteLayoutCleanup = (snapshot) => {
  if (!snapshot || typeof window === "undefined") {
    return;
  }

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => cleanupDepartingRouteLayout(snapshot));
  });
};
